import { render, staticRenderFns } from "./BasicAddressInfo.vue?vue&type=template&id=16d95544&"
import script from "./BasicAddressInfo.vue?vue&type=script&lang=js&"
export * from "./BasicAddressInfo.vue?vue&type=script&lang=js&"
import style0 from "./BasicAddressInfo.vue?vue&type=style&index=0&id=16d95544&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports